<template>
  <div id="app">
    <!-- Remove any references to Head, Quiz, or Steps components here -->
    <router-view></router-view>
  </div>
</template>

<script>
import branding from '@/config/branding'

export default {
  name: 'App',
  components: {},
  created() {
    // Set favicon based on branding
    this.setFavicon()
    // Set document title based on branding
    this.setDocumentTitle()
  },
  methods: {
    setFavicon() {
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link')
      link.type = 'image/png'
      link.rel = 'icon'
      link.href = branding.favicon
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    setDocumentTitle() {
      document.title = branding.documentTitle
    }
  }
}
</script>

<style>
/* Global font settings */
:root {
  --system-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
}

html, body {
  height: 100%;
  margin: 0;
 
}

#app {
  height: 100%;
  width: 100vw;
  max-width: 100vw;
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

body {
  font-family: var(--system-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Override Element UI default font */
.el-button,
.el-input__inner,
.el-message-box__title,
.el-message-box__message,
.el-notification__title,
.el-notification__content,
.el-menu-item,
.el-submenu__title,
.el-form-item__label,
.el-form-item__content,
.el-dialog__title,
.el-table,
.el-pagination,
.el-dropdown-menu__item,
.el-select-dropdown__item,
.el-card__header,
.el-tabs__item {
  font-family: var(--system-font) !important;
}

.container {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  flex: 1;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Temporary debug styles - with corrected selectors */
.router-view,
.router-view-container {
  width: 100%;
  min-width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  background-color: rgba(255, 0, 0, 0.1); /* Light red background */
}

/* Target immediate child of router-view */
.router-view > *,
.router-view-container > * {
  background-color: rgba(0, 255, 0, 0.1); /* Light green background */
  width: 100%;
  min-width: 100%;
}
</style>
